let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g4hzh")).then(() => parcelRequire('7N8D9'));